/**!
 *
 * common.js
 *
 * @license Copyright (C) 2026 Taichi Matsutaka | RENDAN
 * All rights reserved.
 * This code is proprietary and confidential.
 * Unauthorized copying, sharing, distribution, or use of this code in any form is strictly prohibited.
 *
 */
/**
 *
 * common.js
 *
 *
 */
(() => {


	/**
	 *
	 *
	 * Variable
	 *
	 *
	 */
	/**************************************************************
	 * global
	**************************************************************/
	const root = document.body.dataset.root;
	// const mqUpLg = getComputedStyle(document.documentElement).getPropertyValue('--mqUp-lg');




	/**
	 *
	 * Svg
	 *
	 * imgタグなどからSVGを生成。
	 * common.cssに属するクラスは全てここで一括指定。
	 * ページ固有のものはimgタグやdata属性で直接指定。
	 *
	 */
	window.addEventListener('DOMContentLoaded', () => {
		/**************************************************************
		 * 直接指定
		**************************************************************/
		new changeSvg('img.js-svg',{});
		new changeSvg('[data-class="js-svg"]',{});


		/**************************************************************
		 * 一括指定
		**************************************************************/
		new changeSvg('.c-favo',{
			svg: root + 'assets/icon-favo.svg',
		});
		new changeSvg('.c-account',{
			svg: root + 'assets/icon-account.svg',
		});
		new changeSvg('.c-search',{
			svg: root + 'assets/icon-search.svg',
		});
		new changeSvg('.c-cart',{
			svg: root + 'assets/icon-cart.svg',
		});
		new changeSvg('.c-cart2',{
			svg: root + 'assets/icon-cart2.svg',
		});

		new changeSvg('.c-sns-instagram',{
			svg: root + 'assets/icon-sns_instagram.svg',
		});
		new changeSvg('.c-arrow',{
			svg: root + 'assets/icon-arrow.svg',
		});
		new changeSvg('.c-arrow2',{
			svg: root + 'assets/icon-arrow2.svg',
		});
		new changeSvg('.c-arrow3',{
			svg: root + 'assets/icon-arrow3.svg',
		});
		new changeSvg('.c-down',{
			svg: root + 'assets/icon-down.svg',
		});


	});







	/**
	 *
	 *
	 * Base
	 *
	 *
	 */
	/**************************************************************
	 * useragent
	**************************************************************/
	new uaLite({
		device    : true,
		deviceType: true,
		browser   : true,
		display   : true,
	});


	/**************************************************************
	 * addClass
	**************************************************************/
	window.addEventListener('load',function(){
		document.body.classList.add('is-load');
	});


	/**************************************************************
	 * smoothScroll
	**************************************************************/
	const easingFuncs = new getEasing({
		easing: 'easeInOutExpo',
	});

	new smoothScroll('a[href^="#"]',{
		documentTop   : true,
		easingFunction: easingFuncs,
		minus         : [0],
		speed         : 800,
	});






	/**
	 *
	 *
	 * Layout / Project
	 *
	 *
	 */
	/**************************************************************
	 * headerSticky
	**************************************************************/
	const headerSticky = () => {
		const header = document.querySelector('.l-header');

		const stickyClass = 'is-sticky';
		const accentClass = '-accent';
		const threshold   = 100;

		const hasAccentDefault = header.classList.contains(accentClass);

		let ticking = false;

		const update = () => {
			const sy = window.pageYOffset || document.documentElement.scrollTop || 0;

			if ( sy >= threshold ){
				header.classList.add(stickyClass);
				if (hasAccentDefault) header.classList.remove(accentClass);
			} else {
				header.classList.remove(stickyClass);
				if (hasAccentDefault) header.classList.add(accentClass);
			}

			ticking = false;
		};

		const onScroll = () => {
			if (ticking) return;
			ticking = true;
			requestAnimationFrame(update);
		};

		window.addEventListener('scroll', onScroll, { passive: true });
		update();
	}
	headerSticky();


	/**************************************************************
	 * popup
	**************************************************************/
	new popup('.l-header__button',{
		popupSelector      : '.l-sitemap',
		closeButtonSelector: '.l-sitemap__close',
		breakPointDown     : null,
		animationTime      : 0,
		bg                 : false,
		smoothScroll       :'a[href^="#"]',
		popupOpenClass     : 'is-open',
		buttonOpenClass    : 'is-open',
		bodyOpenClass      : 'is-sitemap-open',
		basicId            : 'aria-sitemap',
		basicIdIndex       : false,
	});


	/**************************************************************
	 * intervalChange
	**************************************************************/
	new intervalChange('.l-header__sub__emoji',{
		sliderSelector: '.l-header__sub__emoji__content',
		autoplay      : true,
		immedStart    : false,
		intervalSpeed : 6000,
		startDelay    : 0,
		put           : false,
		dots          : false,
		counter       : false,
		zIndex        : false,
		navigation    : false,
		addData       : false,
	});


	/**************************************************************
	 * swiper
	**************************************************************/
	new Swiper('.l-category__list', {
		autoplay: {
			delay               : 4000,
			disableOnInteraction: false,
		},
		centeredSlides: true,
		loop          : true,
		speed         : 550,
		slidesPerView : 'auto',
		navigation: {
			prevEl       : '.l-category__arrows li:nth-of-type(1) button',
			nextEl       : '.l-category__arrows li:nth-of-type(2) button',
			disabledClass: 'is-disabled',
			disabledClass          : 'is-disabled',
			hiddenClass            : 'is-hidden',
			lockClass              : 'is-look',
			navigationDisabledClass: 'is-nav-disabled',
		},
	});


	/**************************************************************
	 * swiper : wrapping記事のメイン画像
	**************************************************************/
	document.querySelectorAll('.js-wrapping-slider').forEach(function (root) {
		const dots = root.querySelector('.c-dots');
		new Swiper(root.querySelector('.article-wrapping__slider'), {
			autoplay: {
				delay               : 4000,
				disableOnInteraction: false,
			},
			loop         : true,
			speed        : 550,
			slidesPerView: 1,
			pagination: {
				el               : dots,
				type             : 'bullets',
				clickable        : true,
				bulletClass      : '-bullets',
				bulletActiveClass: 'is-active',
				renderBullet: function (index, className) {
					return '<li class="' + className + '"><button type="button">' + (index + 1) + '</button></li>';
				},
			},
		});
	});


	/**************************************************************
	 * swiper
	**************************************************************/
	const articleFigure = () => {
		const currentEl = document.querySelector('.article__figure__count__current');
		const totalEl   = document.querySelector('.article__figure__count__total');
		const mainEl    = document.querySelector('.p-article__figure__main');
		if (!mainEl) return;

		const syncVideo = (swiper) => {
			const slides = swiper.slides || [];
			const active = slides[swiper.activeIndex];
			for (let i = 0; i < slides.length; i++) {
				const videos = slides[i].querySelectorAll('video');
				for (let j = 0; j < videos.length; j++) {
					videos[j].pause();
					try {
						videos[j].currentTime = 0;
					} catch (e) {}
				}
			}
			if (!active) return;
			const video = active.querySelector('video');
			if (!video) return;
			const playPromise = video.play();
			if (playPromise && typeof playPromise.catch === 'function') {
				playPromise.catch(function () {});
			}
		};

		const subSwiper = new Swiper('.p-article__figure__sub', {
			speed              : 550,
			slidesPerView      : 'auto',
			watchSlidesProgress: true,
		});
		const mainSwiper = new Swiper('.p-article__figure__main', {
			centeredSlides: true,
			loop          : true,
			speed         : 550,
			slidesPerView : 1,
			navigation: {
				nextEl: '.p-article__figure__next',
				prevEl: '.p-article__figure__prev',
			},
			thumbs: {
				swiper: subSwiper,
			},
			on: {
			init(swiper) {
					if (currentEl) currentEl.textContent = String(swiper.realIndex + 1);
					if (totalEl) totalEl.textContent = String(subSwiper.slides.length);
					syncVideo(swiper);
				},
				slideChange(swiper) {
					if (currentEl) currentEl.textContent = String(swiper.realIndex + 1);
				},
				slideChangeTransitionEnd(swiper) {
					syncVideo(swiper);
				},
			},
		});
	}
	articleFigure();









	/**
	 *
	 *
	 * UI
	 *
	 *
	 */
	/**************************************************************
	 * cursor
	**************************************************************/
	new cursor({
		cursorClass    : ['js-cursor'],
		firstClass     : ['js-cursor__arrow'],
		firstSpeed     : 0.2,
		firstInnerHTML : '<img src="'+ root +'assets/icon-arrow3.svg" alt=""><img src="'+ root +'assets/icon-arrow3.svg" alt="">',
		addStyle       : true,
		zindexBase     : 2147483648, // 最大値 + 1
		position       : 1,
		hovers :[
			[ '.p-article__figure__next' , 'is-next' ],
			[ '.p-article__figure__prev' , 'is-prev' ],
		],
	});


	/**************************************************************
	 * intervalChange
	**************************************************************/
	new intervalChange('.js-slider-num',{
		sliderSelector       : '.js-slider__content',
		autoplay             : true,
		immedStart           : false,
		intervalSpeed        : 2000,
		startDelay           : 0,
		put                  : false,
		dots                 : false,
		counter              : false,
		zIndex               : false,
		navigation           : false,
		addData              : false,
		dotsClass            : ['c-dots'],
	});

	new intervalChange('.js-slider-dots',{
		sliderSelector       : '.js-slider__content',
		autoplay             : true,
		immedStart           : false,
		intervalSpeed        : 2000,
		startDelay           : 0,
		put                  : false,
		dots                 : true,
		dotsSelector         : null,
		dotsChildrenSelector : 'li',
		dotsContainerSelector: null,
		dotsContainerType    : 'target',
		dotsInnerHTML        : '<button type="button"></button>',
		dotsActiveClass      : 'is-active',
		counter              : false,
		zIndex               : false,
		navigation           : false,
		addData              : false,
		dotsClass            : ['c-dots'],
	});

	/**************************************************************
	 * slider dots swipe (max-width: 750px)
	**************************************************************/
	const initSliderDotsSwipe = () => {
		const mqMobile = window.matchMedia('(max-width: 750px)');
		const roots = document.querySelectorAll('.js-slider-dots');

		for ( let i = 0; i < roots.length; i++ ){
			const root = roots[i];
			if ( root.dataset.swipeInit === '1' ) continue;

			const dots = root.querySelectorAll('.c-dots li');
			if ( dots.length < 2 ) continue;

			root.dataset.swipeInit = '1';

			let ptrId = null;
			let startX = 0;
			let startY = 0;

			const getActiveIndex = () => {
				for ( let j = 0; j < dots.length; j++ ){
					if ( dots[j].classList.contains('is-active') ) return j;
				}
				return 0;
			};

			const clickDot = ( index ) => {
				if ( index < 0 || index >= dots.length ) return;
				const btn = dots[index].querySelector('button');
				if ( btn ) btn.click();
			};

			const onPointerEnd = ( e ) => {
				if ( ptrId === null || e.pointerId !== ptrId ) return;
				document.removeEventListener('pointerup', onPointerEnd);
				document.removeEventListener('pointercancel', onPointerEnd);

				const dx = e.clientX - startX;
				const dy = e.clientY - startY;
				ptrId = null;

				if ( !mqMobile.matches ) return;
				if ( Math.abs(dx) < 48 ) return;
				if ( Math.abs(dx) < Math.abs(dy) * 1.2 ) return;

				const n = dots.length;
				const cur = getActiveIndex();
				if ( dx < 0 ){
					clickDot((cur + 1) % n);
				} else {
					clickDot((cur - 1 + n) % n);
				}
			};

			root.addEventListener('pointerdown', ( e ) => {
				if ( !mqMobile.matches ) return;
				if ( ptrId !== null ) return;
				if ( e.pointerType === 'mouse' && e.button !== 0 ) return;

				ptrId = e.pointerId;
				startX = e.clientX;
				startY = e.clientY;

				document.addEventListener('pointerup', onPointerEnd);
				document.addEventListener('pointercancel', onPointerEnd);
			});
		}
	};
	initSliderDotsSwipe();


	/**************************************************************
	 * initLooptxtClone
	**************************************************************/
	const initLooptxtClone = () => {
		const targets = document.querySelectorAll('.c-looptxt .js-loopslider__content');

		for ( let i = 0; i < targets.length; i++ ){
			const target    = targets[i];
			const randomNum = Math.floor(Math.random() * 10) + 1;

			for ( let j = 0; j < 3; j++ ){
				const wrap = document.createElement('div');
				const img  = document.createElement('img');

				img.src = root + 'assets/looptxt_' + randomNum + '.svg';
				img.alt = '';
				img.decoding = 'async';

				wrap.appendChild(img);
				target.appendChild(wrap);
			}
		}
	}
	initLooptxtClone();


	/**************************************************************
	 * loopSlider
	**************************************************************/
	imagesLoaded( document.querySelectorAll('.js-loopslider img,.js-loopslider-mqUp-lg img'), function( instance ) {
		new loopSlider( '.js-loopslider:not(.-column),.js-loopslider-mqUp-lg:not(.-column)', {
			mediaQuery    : null,
			sliderSelector: '.js-loopslider__content',
			resizeDelay   : 0,
			type          : 'horizontal',
			clone         : 4,
			speed         : 0.65,
			// speed         : 2,
			addSize       : 10,
		});

		new loopSlider( '.js-loopslider.-column', {
			mediaQuery    : null,
			sliderSelector: '.js-loopslider__content',
			resizeDelay   : 0,
			type          : 'vertical',
			clone         : 4,
			speed         : 0.5,
			// speed         : 2,
			addSize       : 10,
		});
	});


	/**************************************************************
	 * accordion
	 * hoverとclickで親要素のクラスを変えて振り分ける
	 * 小要素のクラスは同じ
	 * スタイルは各々で指定する
	**************************************************************/
	new accordion('.js-accordion-click',{
		addHeight           : true,
		transitionDuration  : 500,
		switchSelector      : '.js-accordion__switch',
		closeSwitchSelector : null,
		panelSelector       : '.js-accordion__panel',
		event               : 'click',
		anotherElementClose : true,
		openClass           : 'is-open',
		firstOpenClass      : 'is-first',
		basicId             : 'aria-accordion-',
		onInit : null,
		onOpen : null,
		onClose: null,
	});
	new accordion('.js-accordion-hover',{
		transitionDuration : 500,
		addHeight          : true,
		switchSelector     : '.js-accordion__switch',
		closeSwitchSelector: null,
		panelSelector      : '.js-accordion__panel',
		event              : 'hover',
		anotherElementClose: true,
		openClass          : 'is-open',
		firstOpenClass     : 'is-first',
		basicId            : 'aria-accordion-',
		onInit : null,
		onOpen : null,
		onClose: null,
	});








	/**
	 *
	 *
	 * Effect
	 *
	 *
	 */
	/**************************************************************
	 * scrollClass
	**************************************************************/
	window.addEventListener('load', () => {
		const target = document.querySelectorAll('header[class*="p-hero"],.js-load-trigger');

		for (let i = 0; i < target.length; i++) {
			target[i].classList.add('is-shown');
		}
	});


	new scrollClass('.js-trigger',{
		addClass: 'is-shown',
		IntersectionObserverOptions: {
			rootMargin: '-20% 0px -20%', // 5
		},
	});




})();

/**
 *
 * _articleForm.js
 *
 *
 */
(() => {


	/**
	 *
	 *
	 * Variable
	 *
	 *
	 */
	/**************************************************************
	 * global
	**************************************************************/
	const root = document.body.dataset.root;
	// const mqUpLg = getComputedStyle(document.documentElement).getPropertyValue('--mqUp-lg');




	/**
	 *
	 *
	 * Base
	 *
	 *
	 */
	/**************************************************************
	 * articleForm
	**************************************************************/
	const articleForm = () => {
		const forms = document.querySelectorAll('.p-article__form');
		if (!forms.length) return;

		for (let i = 0; i < forms.length; i++){
			const form = forms[i];

			/**************************************************************
			 * select
			**************************************************************/
			const selectWraps = form.querySelectorAll('.p-article__form__select');

			for (let j = 0; j < selectWraps.length; j++){
				const wrap = selectWraps[j];

				// div と select が同じクラス名なので、役割で取得
				const txt = wrap.querySelector('.p-article__form__select__txt');
				const select = wrap.tagName.toLowerCase() === 'select'
					? wrap
					: wrap.querySelector('select.p-article__form__select');

				if (!txt || !select) continue;

				const syncSelectText = () => {
					const option = select.options[select.selectedIndex];
					txt.textContent = option ? option.textContent : '';
				};

				syncSelectText();
				select.addEventListener('change', syncSelectText);
			}

			/**************************************************************
			 * color
			**************************************************************/
			const colorWrap = form.querySelector('.p-article__form__color');
			if (colorWrap){
				const colorValue = colorWrap.querySelector('.p-article__form__color__value');
				const colorInputs = colorWrap.querySelectorAll('input[type="radio"][name="color-option"]');

				const syncColorValue = () => {
					let checked = null;

					// checked を探す
					for (let k = 0; k < colorInputs.length; k++){
						if (colorInputs[k].checked){
							checked = colorInputs[k];
							break;
						}
					}

					// 1つも checked がなければ先頭を初期値にする
					if (!checked && colorInputs.length > 0){
						colorInputs[0].checked = true;
						checked = colorInputs[0];
					}

					// is-active の付け外し
					for (let k = 0; k < colorInputs.length; k++){
						const input = colorInputs[k];
						const label = input.closest('label');

						if (!label) continue;

						if (input.checked){
							label.classList.add('is-active');
						} else {
							label.classList.remove('is-active');
						}
					}

					// 表示文字更新
					if (checked && colorValue){
						colorValue.textContent = checked.value;
					}
				};

				syncColorValue();

				for (let k = 0; k < colorInputs.length; k++){
					colorInputs[k].addEventListener('change', syncColorValue);
				}
			}

			/**************************************************************
			 * number
			**************************************************************/
			const quantityWrap = form.querySelector('.p-article__form__quantity');
			if (quantityWrap){
				const buttons = quantityWrap.querySelectorAll('button');
				const input = quantityWrap.querySelector('input[type="number"]');

				if (buttons.length >= 2 && input){
					const minusBtn = buttons[0];
					const plusBtn = buttons[1];

					const getStep = () => {
						const step = Number(input.step);
						return step > 0 ? step : 1;
					};

					const getMin = () => {
						const min = Number(input.min);
						return Number.isNaN(min) ? 1 : min;
					};

					const getMax = () => {
						// max未指定 or 空文字なら制限なし
						if (!input.hasAttribute('max') || input.max === '') return null;

						const max = Number(input.max);
						return Number.isNaN(max) ? null : max;
					};

					const normalizeValue = () => {
						let value = Number(input.value);
						const min = getMin();
						const max = getMax();

						if (Number.isNaN(value)) value = min;
						if (value < min) value = min;
						if (max !== null && value > max) value = max;

						input.value = String(value);
					};

					minusBtn.addEventListener('click', () => {
						normalizeValue();

						const value = Number(input.value);
						const step = getStep();
						const min = getMin();
						const max = getMax();

						let nextValue = value - step;

						if (nextValue < min) nextValue = min;
						if (max !== null && nextValue > max) nextValue = max;

						input.value = String(nextValue);
						input.dispatchEvent(new Event('change', { bubbles: true }));
					});

					plusBtn.addEventListener('click', () => {
						normalizeValue();

						const value = Number(input.value);
						const step = getStep();
						const max = getMax();

						let nextValue = value + step;

						if (max !== null && nextValue > max){
							nextValue = max;
						}

						input.value = String(nextValue);
						input.dispatchEvent(new Event('change', { bubbles: true }));
					});

					input.addEventListener('input', normalizeValue);
					input.addEventListener('blur', normalizeValue);

					normalizeValue();
				}
			}
		}
	};
	articleForm();














})();
